// 首页
import request from '@/utils/request'

// 公司管理主页························start
// 所有数据
export function companyPageList(params) {
  return request({
    url: '/v3/user/company/companyPageList',
    method: 'post',
    data: params
  })
}
export function listByCompanyParentId(params) {
  return request({
    url: '/v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
export function listByCompanyParentId2(params) {
  return request({
    url: '/v3/user/company/listByCompanyParentId2',
    method: 'post',
    data: params
  })
}
export function getCompanyById(params) {
  return request({
    url: '/v3/user/company/getCompanyById',
    method: 'post',
    data: params
  })
}
// 新增公司
export function insert(params) {
  return request({
    url: '/v3/user/company/insert',
    method: 'post',
    data: params
  })
}
// 编辑公司
export function update(params) {
  return request({
    url: '/v3/user/company/update',
    method: 'post',
    data: params
  })
}
// 删除一条公司记录
export function deleteById(params) {
  return request({
    url: '/v3/user/company/deleteById',
    method: 'post',
    data: params
  })
}
// 分公司详情页························start
// 公司用户详情页························start
// 公司用户
export function pageList(params) {
  return request({
    url: '/v3/user/user/userV3PageList',
    method: 'post',
    data: params
  })
}
// 新增公司用户
export function saveUserInfo(params) {
  return request({
    url: '/v3/user/company/saveUserInfo',
    method: 'post',
    data: params
  })
}

// 编辑公司用户
export function updateById(params) {
  return request({
    url: '/v3/user/user/updateById',
    method: 'post',
    data: params
  })
}
// 删除公司用户
export function deleteById2(params) {
  return request({
    url: '/v3/user/user/deleteById',
    method: 'post',
    data: params
  })
}
// 公司用户角色下拉框
export function getRoles(params) {
  return request({
    url: '/v3/user/userRole/getRoles',
    method: 'post',
    data: params
  })
}
// 保存公司用户角色
export function insertUserAndRoles(params) {
  return request({
    url: '/v3/user/userRole/insertUserRoles',
    method: 'post',
    data: params
  })
}
// 修改用户密码--提交
export function resetPassword(params) {
  return request({
    url: '/v3/user/user/resetPassword',
    method: 'post',
    data: params
  })
}

//上传图片
export function uploadImg(params) {
  console.log('uploadImg:params',params)
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/commUpload/upload/'+params.childDir,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
//新增客户化配置
export function addCustDeploymen(params) {
  return request({
    url: '/v3/manager/custDeploymen/add',
    method: 'post',
    data: params
  })
}
//编辑客户化配置
export function editCustDeploymen(params) {
  return request({
    url: '/v3/manager/custDeploymen/edit',
    method: 'post',
    data: params
  })
}